module.exports = __webpack_public_path__ + "static/img/年度最佳空调.06daa98a.png";